import Inset from "./Inset";

export default Inset;
